import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify';

import { ICategory } from '../../../types/category'
import { IProgram, ProgramMethod } from '../../../types/program';
import { IDraw } from '../../../types/draw';
import { ComponentMethod, IComponent } from '../../../types/component';
import { IParameter } from '../../../types/parameter';
import { IProgramFunction } from '../../../types/program_function';
import { IMetaParameter } from '../../../types/meta_paramter';

import 'react-toastify/dist/ReactToastify.css';

import useGetCategories from '../../../hooks/category/useGetCategories';

import MainLayout from '../../layouts/MainLayout';

import DeleteModal from '../../modals/DeleteModal';
import Modal from '../../modals/Modal';

import Sidebar from '../../subcomponents/categories/Sidebar';
import Category from '../../subcomponents/categories/Category';
import Program from '../../subcomponents/categories/Program';
import Component from '../../subcomponents/categories/Component';
import ProgramFunction from '../../subcomponents/categories/ProgramFunction';
import Parameter from '../../subcomponents/categories/Parameter';
import useGetMetaFunctions from '../../../hooks/meta-function/useGetMetaFunctions';

import { groups } from '../../../data/dummy_categories';
import TagsModal from '../../modals/Tags';

const Categories = () => {
    const newCategory: ICategory = {
        group: groups[0].value,
        name: '',
        description: '',
        programs: [] as IProgram[],
        draws: [] as IDraw[]
    };

    const newProgram: IProgram = {
        name: '',
        description: '',
        gov_url: '',
        active: true,
        method: ProgramMethod.AND,
        components: [] as IComponent[],
        program_tags: [],
        province_id: null,
    };

    const newComponent: IComponent = {
        description: '',
        method: ComponentMethod.AND,
        program_functions: [] as IProgramFunction[]
    };

    const newProgramFunction: IProgramFunction = {
        name: '',
        description: '',
        parameters: [] as IParameter[]
    };

    const newParameter: IParameter = {
        name: '',
        description: '',
        value: ''
    };

    const [categories, setCategories] = useState<ICategory[]>([]);
    const [currOption, setCurrOption] = useState<number[]>([]);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
    const [isDelete, setIsDelete] = useState<boolean>(false);
    const [isAction, setIsAction] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [deleteModalMessage, setDeleteModalMessage] = useState<{ title: string; subtitle: string }>({ title: '', subtitle: '' });
    const [currCategory, setCurrentCategory] = useState<ICategory>(!!categories[currOption[0]] ? categories[currOption[0]] : newCategory);
    const [currProgram, setCurrentProgram] = useState<IProgram>(!!currCategory.programs[currOption[1]] ? currCategory.programs[currOption[1]] : newProgram);
    const [currComponent, setCurrentComponent] = useState<IComponent>(!!currProgram.components[currOption[2]] ? currProgram.components[currOption[2]] : newComponent);
    const [currProgramFunction, setCurrentProgramFunction] = useState<IProgramFunction>(!!currComponent.program_functions[currOption[3]] ? currComponent.program_functions[currOption[3]] : newProgramFunction);
    const [currParameter, setCurrentParameter] = useState<IParameter>(!!currProgramFunction.parameters[currOption[4]] ? currProgramFunction.parameters[currOption[4]] : newParameter);
    const [relatedMetaParameters, setRelatedMetaParameters] = useState<IMetaParameter[]>([]);
    const [isResetNew, setIsResetNew] = useState<boolean>(false);
    const [duplicateModalText, setDuplicateModalText] = useState<{ title: string; subtitle: string }>({ title: '', subtitle: '' });
    const [isDuplicateModal, setCreateDuplicateModal] = useState<boolean>(false);
    const [isCreateDuplicate, setCreateDuplicate] = useState<boolean>(false);
    const [isTagsModalOpen, setIsTagsModalOpen] = useState<boolean>(false);

    const { data: allCategories, isPending, isError } = useGetCategories();
    const { data: metaFunctions, isPending: isPendingMetaFunctions, isError: isErrorMetaFunctions } = useGetMetaFunctions('program');

    useEffect(() => {
        if (!currOption.length) {
            setCurrOption([0]);
        }
        setCategories(allCategories ? allCategories : []);
    }, [allCategories]); //eslint-disable-line

    useEffect(() => {
        if (currOption.length >= 1) {
            setCurrentCategory(categories[currOption[0]] ? categories[currOption[0]] : newCategory);
        }
        if (currOption.length >= 2) {
            setCurrentProgram(categories[currOption[0]].programs[currOption[1]] ? categories[currOption[0]].programs[currOption[1]] : { ...newProgram, category_id: categories[currOption[0]].id });
        }
        if (currOption.length >= 3) {
            setCurrentComponent(categories[currOption[0]].programs[currOption[1]].components[currOption[2]] ? categories[currOption[0]].programs[currOption[1]].components[currOption[2]] : { ...newComponent, program_id: categories[currOption[0]].programs[currOption[1]].id });
        }
        if (currOption.length >= 4) {
            setCurrentProgramFunction(categories[currOption[0]].programs[currOption[1]].components[currOption[2]].program_functions[currOption[3]] ? categories[currOption[0]].programs[currOption[1]].components[currOption[2]].program_functions[currOption[3]] : { ...newProgramFunction, component_id: categories[currOption[0]].programs[currOption[1]].components[currOption[2]].id });
        }
        if (currOption.length >= 5) {
            setCurrentParameter(categories[currOption[0]].programs[currOption[1]].components[currOption[2]].program_functions[currOption[3]].parameters[currOption[4]]
                ? categories[currOption[0]].programs[currOption[1]].components[currOption[2]].program_functions[currOption[3]].parameters[currOption[4]]
                : { ...newParameter, program_function_id: categories[currOption[0]].programs[currOption[1]].components[currOption[2]].program_functions[currOption[3]].id });
        }
    }, [categories, currOption]); //eslint-disable-line

    useEffect(() => {
        if (metaFunctions && currProgramFunction.id) {
            setRelatedMetaParameters(metaFunctions.find(metaFunction => metaFunction.name === currProgramFunction.name)?.parameters || []);
        }
    }, [currProgramFunction, metaFunctions]);

    if (isPending || isPendingMetaFunctions) return <div>Loading...</div>
    if (isError || isErrorMetaFunctions) return <div>Error</div>

    return (
        <>
            {isOpenDeleteModal && <DeleteModal setIsOpenDeleteModal={setIsOpenDeleteModal} setIsDelete={setIsDelete} title={deleteModalMessage.title} subtitle={deleteModalMessage.subtitle} />}
            {isOpenModal && <Modal setIsOpenModal={setIsOpenModal} setIsAction={setIsAction} title={deleteModalMessage.title} subtitle={deleteModalMessage.subtitle} />}
            {isDuplicateModal && <Modal setIsOpenModal={setCreateDuplicateModal} setIsAction={setCreateDuplicate} title={duplicateModalText.title} subtitle={duplicateModalText.subtitle} />}
            {isTagsModalOpen && <TagsModal
                isTagsModalOpen={isTagsModalOpen}
                setIsTagsModalOpen={setIsTagsModalOpen}
            />}

            <MainLayout>
                <div className='imm_admin__main_view'>
                    <Sidebar currOption={currOption} setCategories={setCategories} setCurrOption={setCurrOption} categories={categories} isResetNew={isResetNew} setIsResetNew={setIsResetNew} />
                    <div className='imm_admin__main_content'>
                        {currOption.length === 1 && <Category setDuplicateModalText={setDuplicateModalText} setCreateDuplicateModal={setCreateDuplicateModal} setCreateDuplicate={setCreateDuplicate} isCreateDuplicate={isCreateDuplicate} setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} category={currCategory} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} disableDelete={categories.length === 1} setIsResetNew={setIsResetNew} />}
                        {currOption.length === 2 &&
                            <Program
                                setDuplicateModalText={setDuplicateModalText}
                                setCreateDuplicateModal={setCreateDuplicateModal}
                                setCreateDuplicate={setCreateDuplicate}
                                isCreateDuplicate={isCreateDuplicate}
                                setDeleteModalMessage={setDeleteModalMessage}
                                currOption={currOption}
                                setCurrOption={setCurrOption}
                                program={currProgram}
                                isDelete={isDelete}
                                setIsDelete={setIsDelete}
                                setIsOpenDeleteModal={setIsOpenDeleteModal}
                                setIsResetNew={setIsResetNew}
                                setIsTagsModalOpen={setIsTagsModalOpen}
                            />
                        }
                        {currOption.length === 3 && <Component setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} component={currComponent} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} setIsResetNew={setIsResetNew} />}
                        {currOption.length === 4 && <ProgramFunction setDuplicateModalText={setDuplicateModalText} setCreateDuplicate={setCreateDuplicate} isCreateDuplicate={isCreateDuplicate} setCreateDuplicateModal={setCreateDuplicateModal} setIsOpenModal={setIsOpenModal} isAction={isAction} setIsAction={setIsAction} setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} metaFunctions={metaFunctions} programFunction={currProgramFunction} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} setIsResetNew={setIsResetNew} />}
                        {currOption.length === 5 && <Parameter setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} relatedMetaParameters={relatedMetaParameters} parameter={currParameter} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} setIsResetNew={setIsResetNew} />}
                    </div>
                </div>
                <ToastContainer toastStyle={{ fontFamily: 'Poppins', fontSize: '14px' }} autoClose={2000} />
            </MainLayout>
        </>
    );
}

export default Categories;